import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import css from "./Bloginfo.module.scss"
import demo from "../../../assets/images/H-Second.png"


import { useSelector, useDispatch } from 'react-redux';
import { fetchBlogApi } from '../../../redux/slices';
const Bloginfo = ({ blogs }) => {
  // const { title } = useParams(); // Get the blog title from the URL parameter

  // // Find the blog post that matches the title
  // const blog = blogs.find(blog => blog.title === title);

 

  const dispatch = useDispatch();
  const blogData = useSelector((state) => state.blogApi.value);
  const [data, setData] = useState({
    loading: true,
    blogs: [],
  });

  useEffect(() => {
    dispatch(fetchBlogApi())
      .then(() => {
        setData({
          loading: false,
          blogs: blogData ? blogData.data : [],
        });
      })
      .catch((error) => {
        console.error('Error fetching blogs:', error);
        setData({
          loading: false,
          blogs: [],
        });
      });
  }, []);

  useEffect(() => {
    console.log(blogData);
  }, [blogData]);


  return (
    <div className='mt-24'>
    <div className={css.container}>
      <center>
        <h1 className={css.heading}>Lorem Ipsum is simply dummy text of the printing and typesetting industry.</h1>
        <p className={css.para}>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos </p>
        <div className={css.cotainer2}>
          <img src={demo} title='' alt="" className={css.img}/>
        </div>
        <p className={css.para}>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos </p>

      </center>


          <div className={css.container3}>
      <section className={css.section1}>
        <img src={demo} />
      </section>
      <section className={css.section2}>
        <h2 className={css.h1}>We can help you to get software which drives sales Smart Business solutions encompasses Web.</h2>
        <p className={css.para}>We have found a simple solution to a peculiar problem. Finding the right talent for your software project requirements is no more a task to lay down your precious time on. We do the hiring and management of the resources and you keep focus on better and bigger tasks at hand. Choose the best the indust ing the right talent for your software project requirements is no more a task to lay down your precious time on. We do the hiring and management of the resources and you keep focus on better and bigger tasks at hand.  ry has to offer. A wide range of talent is available for hire at Reveation.</p>
      </section> 
      </div>

      <center>
        <p className={css.para}>Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt. Neque porro quisquam est, qui dolorem ipsum quia dolor sit amet, consectetur, adipisci velit, sed quia non numquam eius modi tempora incidunt ut labore et dolore magnam aliquam quaerat voluptatem. Ut enim ad minima veniam, quis nostrum exercitationem ullam corporis suscipit laboriosam, nisi ut aliquid ex ea commodi consequatur? Quis autem vel eum eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos </p>
        <div className={css.cotainer2}>
          <img src={demo} title='' alt="" className={css.img}/>
        </div>
      </center>


      

      </div>
    </div>
  )
}

export default Bloginfo

// import React, { useEffect, useState } from 'react';
// import { useParams } from 'react-router-dom';
// import { useSelector, useDispatch } from 'react-redux';
// import { fetchBlogApi } from '../../../redux/slices';
// import css from './Bloginfo.module.scss';
// import demo from "../../../assets/images/Group 32701.png";
// import { Helmet } from 'react-helmet';


// const Bloginfo = () => {
//   const { title } = useParams(); // Get the blog title from the URL parameter

//   const dispatch = useDispatch();
//   const blogData = useSelector((state) => state.blogApi.value);
//   const [loading, setLoading] = useState(true);
//   const [blog, setBlog] = useState(null);

//   useEffect(() => {
//     dispatch(fetchBlogApi())
//       .then(() => {
//         setLoading(false);
//       })
//       .catch((error) => {
//         console.error('Error fetching blogs:', error);
//         setLoading(false);
//       });
//   }, [dispatch]);

//   useEffect(() => {
//     if (blogData && blogData.data) {
//       const foundBlog = blogData.data.find((blog) => blog.title === title);
//       setBlog(foundBlog);
//     }
//   }, [blogData, title]);

//   if (loading) {
//     return <div>Loading...</div>;
//   }

//   if (!blog) {
//     return <div>Blog not found</div>;
//   }

  
//   return (
//     <div className='mt-24'>
//           <Helmet>
//       <title>{blog.metatitle}</title>
//       <meta name='description' content={blog.metadescription} />
//     </Helmet>

//     <div className={css.container}>
//       <center>
//         <h1 className={css.heading}>{blog.title}</h1>
//         <p className={css.para}>{blog.description}</p>
//         <div className={css.cotainer2}>
//           <img src={blog.feature_image} title={blog.alt} alt={blog.alt} className={css.img}/>
//         </div>
//         <p className={css.para}>{blog.description2}</p>

//       </center>


//           <div className={css.container3}>
//       <section className={css.section1}>
//         <img src={blog.feature_image2} title={blog.alt2} alt={blog.alt2} />
//       </section>
//       <section className={css.section2}>
//         <h2 className={css.h1}>{blog.title2}</h2>
//         <p className={css.para}>{blog.description3}</p>
//       </section> 
//       </div>

//       <center>
//         <p className={css.para}> {blog.description4} </p>
//         <div className={css.cotainer2}>
//           <img src={blog.feature_image3} title={blog.alt2} alt={blog.alt2} className={css.img}/>
//         </div>
//       </center>


      

//       </div>
//     </div>
//   )
// };

// export default Bloginfo;
